const audio = require.context('.', false, /\.mp3$/);
let parseAudio = [];
// console.log( "audio is working" );
audio.keys().forEach((key) => {
  parseAudio.push({
    id: key,
    text: 'audio dla ' + key,
  });
});

// console.log( 'parseAudio', parseAudio );

export default parseAudio;
